import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const FeatureThree = () => {
  const NextArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      type='button'
      id='feature-item-wrapper-next'
      className='slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1'
    >
      <i className='ph ph-caret-right' />
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button
      onClick={onClick}
      type='button'
      id='feature-item-wrapper-prev'
      className='slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-600 hover-text-white transition-1'
    >
      <i className='ph ph-caret-left' />
    </button>
  );
  const settings = {
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 900,
    dots: false,
    pauseOnHover: true,
    arrows: true,
    draggable: true,
    infinite: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 359,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div
      className='feature feature-three mt-0 py-120 overflow-hidden'
      id='featureSection'
    >
      <div className='container container-lg'>
        <div className='section-heading text-center'>
          <h5 className='mb-0  text-uppercase'>Popular Categories</h5>
        </div>
        <div className='position-relative arrow-center'>
          <div className='feature-three-item-wrapper'>
            <Slider {...settings}>
              <div className='feature-item text-center'>
                <div className='feature-item__thumb bg-yellow-light rounded-circle overflow-hidden'>
                  <Link to='/shop?category=Bags' className='w-100 h-100 flex-center'>
                    <img
                      src='assets/images/thumbs/features-three-img1.png'
                      alt=''
                      className='w-100 h-100 object-fit-contain rounded-circle'
                    />
                  </Link>
                </div>
                <div className='feature-item__content mt-20'>
                  <h6 className='text-lg mb-8'>
                    <Link to='/shop?category=Bags' className='text-inherit'>
                      Bags
                    </Link>
                  </h6>
                </div>
              </div>
              <div className='feature-item text-center'>
                <div className='feature-item__thumb bg-danger-light rounded-circle overflow-hidden'>
                  <Link to='/shop?category=Yarn' className='w-100 h-100 flex-center'>
                    <img
                      src='assets/images/thumbs/features-three-img2.png'
                      alt=''
                      className='w-100 h-100 object-fit-contain rounded-circle'
                    />
                  </Link>
                </div>
                <div className='feature-item__content mt-20'>
                  <h6 className='text-lg mb-8'>
                    <Link to='/shop?category=Yarn' className='text-inherit'>
                      Yarn
                    </Link>
                  </h6>
                </div>
              </div>
              <div className='feature-item text-center'>
                <div className='feature-item__thumb bg-purple-light rounded-circle overflow-hidden'>
                  <Link to='/shop?category=Kits' className='w-100 h-100 flex-center'>
                    <img
                      src='assets/images/thumbs/features-three-img3.png'
                      alt=''
                      className='w-100 h-100 object-fit-contain rounded-circle'
                    />
                  </Link>
                </div>
                <div className='feature-item__content mt-20'>
                  <h6 className='text-lg mb-8'>
                    <Link to='/shop?category=Kits' className='text-inherit'>
                      Kits
                    </Link>
                  </h6>
                </div>
              </div>
              <div className='feature-item text-center'>
                <div className='feature-item__thumb bg-danger-light rounded-circle overflow-hidden'>
                  <Link to='/shop?category=Sticks' className='w-100 h-100 flex-center'>
                    <img
                      src='assets/images/thumbs/features-three-img4.png'
                      alt=''
                      className='w-100 h-100 object-fit-contain rounded-circle'
                    />
                  </Link>
                </div>
                <div className='feature-item__content mt-20'>
                  <h6 className='text-lg mb-8'>
                    <Link to='/shop?category=Sticks' className='text-inherit'>
                      Sticks
                    </Link>
                  </h6>
                </div>
              </div>
              <div className='feature-item text-center'>
                <div className='feature-item__thumb bg-warning-light rounded-circle overflow-hidden'>
                  <Link to='/shop?category=Handles' className='w-100 h-100 flex-center'>
                    <img
                      src='assets/images/thumbs/features-three-img5.png'
                      alt=''
                      className='w-100 h-100 object-fit-contain rounded-circle'
                    />
                  </Link>
                </div>
                <div className='feature-item__content mt-20'>
                  <h6 className='text-lg mb-8'>
                    <Link to='/shop?category=Handles' className='text-inherit'>
                      Handles
                    </Link>
                  </h6>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureThree;